// extracted by mini-css-extract-plugin
module.exports = {"auth":"style_auth__19Whw","authForm":"style_authForm__2S8IS","field":"style_field__MWT0a","button":"style_button__2RuBe","link":"style_link__2TCky"};